var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyword-list"},[_c('div',{staticClass:"pill-button-group"},_vm._l((_vm.keywords),function(keyword,i){return _c('button',{key:("keyword-" + i),class:[
        'pill-button pill-button--sm pill-button--selectable',
        { 'is-selected': _vm.activeKeywordIds.includes(keyword.id) }
      ],on:{"click":function($event){return _vm.$emit('keyword-click', keyword)}}},[_vm._v(" "+_vm._s(keyword.label)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }